import { IViewProps } from "./CurrencyDisplay";

export const View = (props: IViewProps) => {
  return (
    <>
      <span className="currency-symbol">{props.currencySymbol}</span>
      <span>{props.amount}</span>
    </>
  );
};
